export type CustomerContextMappingErrorCode = 
  | "MISSING_DATAVERSE_ID"
  | "MISSING_REPAIRSHOPR_ID";

export class CustomerContextMappingError extends Error {
  public readonly code: CustomerContextMappingErrorCode;
  public readonly context?: Record<string, unknown>;

  constructor(
    code: CustomerContextMappingErrorCode,
    message: string,
    context?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'CustomerContextMappingError';
    this.code = code;
    this.context = context;
    Object.setPrototypeOf(this, CustomerContextMappingError.prototype);
  }
}
